import {gql} from 'apollo-boost';

export const GET_INFO_GROUPS = gql`
  query getInfoGroups{
    getInfoGroups {
      id color nameLocal nameEng isShow isFix
    }
  }
`;

export const GET_INFO_GROUP = gql`
  query getInfoGroup($id : ID!){
    getInfoGroup (
      id: $id
    ) {
      id color nameLocal nameEng isShow isFix
    }
  }
`;

export const ADD_INFO_GROUP = gql`
  mutation addInfoGroup(
    $infoGroupInput: InfoGroupInput,
  ) {
    addInfoGroup(
      infoGroupInput: $infoGroupInput
    ) {
      id color nameLocal nameEng isShow isFix
    }
  }
`;

export const UPDATE_INFO_GROUP = gql`
  mutation updateInfoGroup(
    $id: ID!,
    $infoGroupInput: InfoGroupInput!
  ) {
    updateInfoGroup(
      id: $id
      infoGroupInput: $infoGroupInput
    ) {
      id color nameLocal nameEng isShow isFix
    }
  }
`;

export const DELETE_INFO_GROUP = gql`
  mutation deleteInfoGroup($id: ID!) {
    deleteInfoGroup(
      id: $id
    ) {
      id color nameLocal nameEng isShow isFix
    }
  }
`;

